import React from 'react';
import { H4, Body1 } from '@xo-union/tk-ui-typography';
import PageHeader from '~/glm/components/shared/layout/page-header';
import AddressCollectionUrl from '~/glm/components/address-collection/address-collection-url';
import styles from './address-collection-page-header.scss';

const heading = <H4 className={styles.addressCollectionHeader}>Send Guests Your Address Collection Form</H4>;

const subHeading = (
  <>
    <Body1>Sit back and save time by sending your link to loved ones. This way, they can add themselves</Body1>
    <Body1>(and all their need-to-know info) directly to your Guest List.</Body1>
    <AddressCollectionUrl />
  </>
);

const AddressCollectionPageHeader = () => (
  <React.Fragment>
    <PageHeader heading={heading} subHeading={subHeading} />
  </React.Fragment>
);

export default AddressCollectionPageHeader;
